module.exports = __webpack_public_path__ + "assets/img/9b7f-hr.svg";